import { IValidationUserResponses } from 'types/UserResponses'

export type ValidationDialogOpenState = 'UNDEFINED' | 'OPEN' | 'CLOSED'

export const validationDialogState = {
  isDialogOpenState: 'UNDEFINED' as ValidationDialogOpenState,
  isInitiativeAlertState: 'UNDEFINED' as ValidationDialogOpenState,
  validation: null as IValidationUserResponses
}

export type ValidationDialogState = typeof validationDialogState
